var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ed-loading-bars h-100 w-100 bsx-d-flex bsx-flex-column edg-shimmer-container"},_vm._l((_vm.rows),function(index){return _c('span',{key:index,staticClass:"edg-shimmer"})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }